export const enums = {

    gender: {
        1: 'M',
        2: 'F',
        3: 'Other',
        4: 'Other',
    },
    // gender: {
    //     1: 'Man',
    //     2: 'Woman',
    //     3: 'Nonbinary',
    // },
    present_or_deceased: {
        1: 'Living',
        2: 'Deceased',
    },
    marital_status: {
        1: 'Single/Divorced',
        2: 'Married',
        3: 'In Relationship',
        4: 'Widowed',
        5: 'Separated',
        6: 'Remarried',
    },
    cell_type:{
        1: "iPhone",
        2: "Android",
        3: "No Phone"
    },
    multiple_births_type: {
        2: 'Twins (2)',
        3: 'Triplets (3)',
        4: 'Quadruplets (4)',
        5: 'Quintuplets (5)',
        6: 'Sextuplets (6)',
        7: 'Septuplets (7)',
        8: 'Octuplets (8)',
        9: 'Nuntuplets (9)',
    }
}